import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ShareFeatureFlags_AdHocAssetsShare_Fragment = { __typename?: 'AdHocAssetsShare', featureFlags?: Array<{ __typename?: 'FeatureFlag', enabled: boolean, name: string } | null> | null };

export type ShareFeatureFlags_CollectionShare_Fragment = { __typename?: 'CollectionShare', featureFlags?: Array<{ __typename?: 'FeatureFlag', enabled: boolean, name: string } | null> | null };

export type ShareFeatureFlagsFragment = ShareFeatureFlags_AdHocAssetsShare_Fragment | ShareFeatureFlags_CollectionShare_Fragment;

export const ShareFeatureFlags = /*#__PURE__*/ gql`
    fragment ShareFeatureFlags on Share {
  featureFlags(flagNames: $flagNames) {
    enabled
    name
  }
}
    ` as unknown as DocumentNode<ShareFeatureFlagsFragment, unknown>;

        

        
export const useShareFeatureFlagsFragment = (
  input: string | Omit<UseFragmentOptions<ShareFeatureFlagsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Share' } };
    return input;
  })();

  return useFragment<ShareFeatureFlagsFragment>({
    fragment: ShareFeatureFlags,
    fragmentName: 'ShareFeatureFlags',
    ...options,
  });
};
  
        